// extracted by mini-css-extract-plugin
export default {"form":"Enquiry_form__eRxnX","enquiryFrom":"Enquiry_enquiryFrom__GkD5K","inputClass":"Enquiry_inputClass__SR8Wv","btn":"Enquiry_btn__6MB4q","row":"Enquiry_row__lDuYF"};